import { SkeletonBlock, type SkeletonBlockProps } from './SkeletonBlock';
import { SkeletonText, type SkeletonTextProps } from './SkeletonText';
import { SkeletonCircle, type SkeletonCircleProps } from './SkeletonCircle';
import { SkeletonFrom, type SkeletonFromProps } from './SkeletonFrom';

export const Skeleton = {
  Block: SkeletonBlock,
  Circle: SkeletonCircle,
  Text: SkeletonText,
  From: SkeletonFrom,
};

export type {
  SkeletonBlockProps,
  SkeletonCircleProps,
  SkeletonFromProps,
  SkeletonTextProps,
};
